import _ from '@lodash';
import { format, compareAsc } from 'date-fns';
import MeasurementTableDto from 'app/admin/measurement/dto/MeasurementTableDto';
import IdentifiableDto from 'modules/base/dto/IdentifiableDto';
import EdaItemTableDto from './EdaItemTableDto';
import EdaStatusType from './EdaStatusType';

export default class EdaTableDto extends IdentifiableDto {
	constructor() {
		super();
		/** @type {MeasurementTableDto[]} */
		this.measurementList = null;
		/** @type {EdaItemTableDto[]} */
		this.itemList = null;
		/** @type {string} */
		this.status = null;
		/** @type {string} */
		this.file = null;
		/** @type {Date} */
		this.created = null;
		/** @type {Date} */
		this.updated = null;
	}

	/**
	 * @typedef {Object} _EdaTableDtoProps
	 * @property {MeasurementTableDto[]} measurementList
	 * @property {EdaItemTableDto[]} itemList
	 * @property {string} status
	 * @property {string} file
	 * @property {Date} created
	 * @property {Date} updated
	 *
	 * @typedef {import("modules/base/dto/IdentifiableDto").IdentifiableDtoProps & _EdaTableDtoProps} EdaTableDtoProps
	 */
	/**
	 *
	 * @param {EdaTableDtoProps} props
	 * @returns {EdaTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.measurementList = _.isArray(props.measurementList) ? props.measurementList.map(d => new MeasurementTableDto().setup(d)) : [];
		this.itemList = _.isArray(props.itemList) ? props.itemList.map(d => new EdaItemTableDto().setup(d)) : [];
		this.status = props.status;
		this.file = props.file;
		this.created = props.created != null ? new Date(props.created) : null;
		this.updated = props.updated != null ? new Date(props.updated) : null;
		return this;
	}

	getAsString(key) {
		if (key === 'status') {
			return this.status != null ? EdaStatusType[this.status] : '';
		}
		if (key === 'measurementListText') {
			if (this.measurementList.length > 3) {
				return `${this.measurementList.map(d => d.name).join(', ')}...`;
			}
			if (this.measurementList.length > 0) {
				return this.measurementList.map(d => d.name).join(', ');
			}
			return '';
		}
		if (key === 'edaTypeListText') {
			const result = [];
			this.itemList.forEach(item => {
				const edaType = item.edaType.name;
				if (result.indexOf(edaType) === -1) result.push(edaType);
			});
			if (result.length > 0) return result.join(', ');

			return '';
		}
		if (key === 'deviceListText') {
			const result = [];
			this.measurementList.forEach(m => {
				if (m.device && result.indexOf(m.device.name) === -1) result.push(m.device.name);
			});
			if (result.length > 0) return result.join(', ');
			return '';
		}
        if (key === 'infrastructureElementListText') {
			if (this.measurementList.length > 0) {
                const result = [];
				this.measurementList.forEach(d => {
                    if( d.infrastructureElement && result.indexOf(d.infrastructureElement.name) === -1 )
                        result.push(d.infrastructureElement.name);
                });
                return result.join(', ');
			}
			return '';
		}
        if (key === 'measurementCreatedListText') {
			if (this.measurementList.length > 0) {
                const result = [];
				this.measurementList.forEach(d => {
                    if( d.created && result.indexOf(d.created) === -1 )
                        result.push(d.created);
                });
                return result.sort(compareAsc).map(d => format(d, 'yyyy.MM.dd. HH:mm')).join(', ');
			}
			return '';
		}

		return super.getAsString(key);
	}
}
